export const getCustomSortColumnViewItems = (customSort, api) => {
    return {
        name: 'Column',
        values: [api.columnApi.getFriendlyNameForColumnId(customSort.ColumnId)],
    };
};
